import { cn } from "../../lib/cn";
export { SegmentedControl } from "./SegmentedControl";

export function DashboardLayout({
  title,
  description,
  actions,
  nav,
  activeId,
  onNavChange,
  sidebarExtra,
  navAriaLabel = "Dashboard",
  children,
}) {
  return (
    <div className="min-h-[calc(100vh-4rem)]">
      <div className="max-w-6xl mx-auto px-4 py-5 sm:py-8 lg:py-10 w-full">
        <div className="flex flex-col lg:flex-row gap-5 sm:gap-8 lg:gap-10 w-full">
          {nav?.length > 0 && (
            <aside className="lg:w-48 xl:w-52 shrink-0">
              {sidebarExtra}
              <nav
                className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0 -mx-1 px-1 scrollbar-none"
                aria-label={navAriaLabel}
              >
                {nav.map((item) => {
                  const active = activeId === item.id;
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => onNavChange?.(item.id)}
                      className={cn(
                        "shrink-0 lg:w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap",
                        active
                          ? "bg-accent text-foreground"
                          : "text-muted-foreground hover:text-foreground hover:bg-muted/60",
                      )}
                    >
                      {item.label}
                    </button>
                  );
                })}
              </nav>
            </aside>
          )}

          <main className="flex-1 min-w-0 w-full">
            <header className="mb-5 sm:mb-8 flex flex-wrap items-start justify-between gap-3 sm:gap-4">
              <div className="min-w-0">
                <h1 className="text-xl sm:text-2xl font-semibold text-foreground tracking-tight">
                  {title}
                </h1>
                {description && (
                  <p className="text-sm text-muted-foreground mt-1 max-w-xl">
                    {description}
                  </p>
                )}
              </div>
              {actions}
            </header>
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
